import { ManageEventsPage } from "./ManageEventsPage";

export default ManageEventsPage;
